import { parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { fetchSessionsMetaData } from "./Sessions.apiCalls";

export const useFetchSessionGlobalRange = (listingUuid = "") => {
  const [loading, setLoading] = useState(true);
  const [globalRange, setGlobalRange] = useState<{
    start: Date | undefined;
    end: Date | undefined;
  }>({
    start: undefined,
    end: undefined,
  });

  useEffect(() => {
    setLoading(true);
    fetchSessionsMetaData({ listingUuid })
      .then((response) => {
        const { data } = response || { start: "", end: "" };
        setGlobalRange({
          start: parseISO(data.first_session_date),
          end: parseISO(data.last_session_date),
        });
      })
      .catch((error) => {
        console.error(error);

        setGlobalRange({
          start: new Date(),
          end: new Date(),
        });
      })
      .finally(() => setLoading(false));
  }, []);

  return { globalRange, isFetched: !loading };
};
